import theme from '@styles/theme';
export default {
  quantityContainer: {
    alignItems: 'center'
  },
  changeQuantityButtonContainer: {
    pl: 0,
    display: 'flex',
    justifyContent: 'flex-start'
  },
  warningWrapper: (miniCart: boolean) => ({
    display: 'flex',
    justifyContent: ['center', 'unset'],
    alignItems: ['center', 'unset'],
    width: miniCart ? 'auto' : ['121px', '121px', '91px'],
    marginRight: miniCart ? '0px' : ['16px', '16px', '0px'],
    pr: miniCart ? '48px' : '0px'
  }),
  availabilityWarningContainer: (isCartPage: boolean) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: isCartPage ? ['0', '0', '24px 0 0'] : '4px 0 0'
  }),
  availabilityWarning: (isCartPage: boolean) => ({
    paddingLeft: '8px',
    paddingTop: isCartPage ? '0px' : '4px',
    color: theme.rawColors.accent700,
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: theme.fontSizes.caption,
    lineHeight: '140%'
  }),
  quantityWarning: {
    width: ['100%', '136px'],
    paddingTop: '4px',
    color: theme.rawColors.accent700,
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: theme.fontSizes.caption,
    lineHeight: '140%'
  },
  deliveryWarning: {
    width: '62px',
    color: theme.rawColors.darkGrey500,
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: theme.fontSizes.caption,
    lineHeight: '140%'
  },
  deliveryWarningIcon: {
    width: '30px',
    height: '25px'
  },
  timeIcon: {
    transform: 'translateY(3px)',
    mr: '10px'
  },
  quantity: {
    width: '136px',
    height: '48px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.rawColors.darkGrey700,
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: theme.fontSizes.text,
    lineHeight: '140%'
  }
};